var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.formItem.deliveryType === "express"
        ? _c(
            "div",
            [
              _c(
                "el-form-item",
                { attrs: { label: "发货类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeSendTypeRadio(
                            _vm.formItem.expressRecordType
                          )
                        },
                      },
                      model: {
                        value: _vm.formItem.expressRecordType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formItem, "expressRecordType", $$v)
                        },
                        expression: "formItem.expressRecordType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("手动填写"),
                      ]),
                      _vm.checkPermi(["admin:order:sheet:info"])
                        ? _c(
                            "el-radio",
                            {
                              attrs: {
                                label: "2",
                                disabled: _vm.merElectPrint == 0,
                              },
                            },
                            [_vm._v("电子面单打印")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formItem.deliveryType === "express"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "快递公司：", prop: "expressCode" } },
                    [
                      _c(
                        "el-select",
                        {
                          style: _vm.isShowBtn ? "width: 82%" : "width:100%",
                          attrs: { filterable: "" },
                          on: { change: _vm.onChangeExpress },
                          model: {
                            value: _vm.formItem.expressCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "expressCode", $$v)
                            },
                            expression: "formItem.expressCode",
                          },
                        },
                        _vm._l(_vm.express, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.id,
                              attrs: { label: item.name, value: item.code },
                            },
                            [
                              _vm._v(_vm._s(item.name) + " "),
                              item.account
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "line-heightOne from-tips",
                                      attrs: { type: "info" },
                                    },
                                    [_vm._v(" | 月结账号已配")]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowBtn,
                              expression: "isShowBtn",
                            },
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["merchant:express:relate"],
                              expression: "['merchant:express:relate']",
                            },
                          ],
                          staticClass: "ml24",
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleCreat },
                        },
                        [_vm._v("设置物流公司")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formItem.expressRecordType === "1"
                ? [
                    _vm.formItem.deliveryType === "express"
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "快递单号：",
                              prop: "expressNumber",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入快递单号" },
                              model: {
                                value: _vm.formItem.expressNumber,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formItem,
                                    "expressNumber",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "formItem.expressNumber",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm.formItem.expressRecordType === "2"
                ? [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "express_temp_id",
                        attrs: {
                          label: "电子面单：",
                          prop: "expressTempId",
                          "label-width": "95px",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          [
                            _c(
                              "el-select",
                              {
                                class: [
                                  _vm.formItem.expressTempId
                                    ? "width9"
                                    : "width8",
                                ],
                                attrs: { placeholder: "请选择电子面单" },
                                on: { change: _vm.onChangeImg },
                                model: {
                                  value: _vm.formItem.expressTempId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formItem, "expressTempId", $$v)
                                  },
                                  expression: "formItem.expressTempId",
                                },
                              },
                              _vm._l(_vm.exportTempList, function (item, i) {
                                return _c("el-option", {
                                  key: i,
                                  attrs: {
                                    value: item.temp_id,
                                    label: item.title,
                                  },
                                })
                              }),
                              1
                            ),
                            _vm.formItem.expressTempId
                              ? _c(
                                  "div",
                                  { staticStyle: { position: "relative" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "tempImgList ml10" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "demo-image__preview",
                                          },
                                          [
                                            _c("el-image", {
                                              staticStyle: {
                                                width: "36px",
                                                height: "36px",
                                              },
                                              attrs: {
                                                src: _vm.tempImg,
                                                "preview-src-list": [
                                                  _vm.tempImg,
                                                ],
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "寄件人姓名：", prop: "toName" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80%" },
                          attrs: { placeholder: "请输入寄件人姓名" },
                          model: {
                            value: _vm.formItem.toName,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "toName", $$v)
                            },
                            expression: "formItem.toName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "寄件人电话：", prop: "toTel" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80%" },
                          attrs: { placeholder: "请输入寄件人电话" },
                          model: {
                            value: _vm.formItem.toTel,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "toTel", $$v)
                            },
                            expression: "formItem.toTel",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "寄件人地址：", prop: "toAddr" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80%" },
                          attrs: { placeholder: "请输入寄件人地址" },
                          model: {
                            value: _vm.formItem.toAddr,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "toAddr", $$v)
                            },
                            expression: "formItem.toAddr",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.formItem.deliveryType === "noNeed"
        ? _c(
            "el-form-item",
            { attrs: { label: "发货备注：" } },
            [
              _c("el-input", {
                attrs: {
                  "show-word-limit": "",
                  autosize: { minRows: 4 },
                  maxlength: "250",
                  type: "textarea",
                  placeholder: "请输入备注信息，最多可输入250字",
                },
                model: {
                  value: _vm.formItem.deliveryMark,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formItem,
                      "deliveryMark",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formItem.deliveryMark",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.formItem.deliveryType === "merchant"
        ? _c(
            "el-form-item",
            { attrs: { label: "配送人员：", prop: "deliveryCarrier" } },
            [
              _c(
                "div",
                { staticClass: "acea-row" },
                [
                  _c(
                    "el-select",
                    {
                      style: _vm.isShowBtn ? "width: 80%" : "width:95%",
                      attrs: {
                        "value-key": "id",
                        filterable: "",
                        clearable: "",
                      },
                      on: { change: _vm.handleChangePersonnel },
                      model: {
                        value: _vm.selectedValue,
                        callback: function ($$v) {
                          _vm.selectedValue = $$v
                        },
                        expression: "selectedValue",
                      },
                    },
                    _vm._l(_vm.personnelList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.personnelName, value: item },
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowBtn,
                          expression: "isShowBtn",
                        },
                      ],
                      staticClass: "ml24",
                      on: {
                        click: function ($event) {
                          return _vm.handleCreatPersonnel()
                        },
                      },
                    },
                    [_vm._v("添加配送员")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.formItem.deliveryType === "merchant"
        ? _c(
            "el-form-item",
            { attrs: { label: "手机号码：", prop: "carrierPhone" } },
            [
              _c("el-input", {
                attrs: { disabled: "", placeholder: "请输入配送人员手机号码" },
                model: {
                  value: _vm.formItem.carrierPhone,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formItem,
                      "carrierPhone",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formItem.carrierPhone",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("creat-express", {
        ref: "craetExpressRef",
        on: { handlerSuccessSubmit: _vm.getList },
      }),
      _c("creat-personnel", {
        attrs: { dialogVisible: _vm.dialogVisible, editData: _vm.editData },
        on: {
          handlerCloseFrom: _vm.handlerCloseFrom,
          handlerSuccessSubmit: _vm.handlerSuccessSubmit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }